<template>
  <div class="add-parking-space-apply-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('addParkingSpaceApply.title')" :subtitle="$t('addParkingSpaceApply.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="_goBack">
          {{ $t('common.back') }}
        </el-button>
        <el-button type="primary" icon="el-icon-check" @click="saveParkingSpaceApplyInfo">
          {{ $t('common.submit') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2)(3)(4) 申请表单面板 -->
    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('addParkingSpaceApply.page.infoTitle') }}</span>
      </div>

      <el-form ref="form" :model="addParkingSpaceApplyInfo" label-width="120px" class="ds-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addParkingSpaceApply.carNum')" prop="carNum" :rules="[
              { required: true, message: $t('addParkingSpaceApply.requiredCarNum') },
              { pattern: /^[\u4e00-\u9fa5A-Za-z0-9]{6,12}$/, message: $t('addParkingSpaceApply.invalidCarNum') }
            ]">
              <el-input v-model.trim="addParkingSpaceApplyInfo.carNum"
                :placeholder="$t('addParkingSpaceApply.placeholderCarNum')" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addParkingSpaceApply.carBrand')" prop="carBrand" :rules="[
              { required: true, message: $t('addParkingSpaceApply.requiredCarBrand') },
              { max: 50, message: $t('addParkingSpaceApply.maxCarBrand') }
            ]">
              <el-input v-model.trim="addParkingSpaceApplyInfo.carBrand"
                :placeholder="$t('addParkingSpaceApply.placeholderCarBrand')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addParkingSpaceApply.carType')" prop="carType"
              :rules="[{ required: true, message: $t('addParkingSpaceApply.requiredCarType') }]">
              <el-select v-model="addParkingSpaceApplyInfo.carType" class="w-full"
                :placeholder="$t('addParkingSpaceApply.placeholderCarType')">
                <el-option v-for="item in carTypes" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12">
            <el-form-item :label="$t('addParkingSpaceApply.carColor')" prop="carColor" :rules="[
              { required: true, message: $t('addParkingSpaceApply.requiredCarColor') },
              { max: 12, message: $t('addParkingSpaceApply.maxCarColor') }
            ]">
              <el-input v-model.trim="addParkingSpaceApplyInfo.carColor"
                :placeholder="$t('addParkingSpaceApply.placeholderCarColor')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="16" :md="16">
            <el-form-item :label="$t('addParkingSpaceApply.applyPersonName')" prop="applyPersonName" :rules="[
              { required: true, message: $t('addParkingSpaceApply.requiredApplyPersonName') },
              { max: 64, message: $t('addParkingSpaceApply.maxApplyPersonName') }
            ]">
              <el-input v-model.trim="addParkingSpaceApplyInfo.applyPersonName"
                :placeholder="$t('addParkingSpaceApply.placeholderApplyPersonName')" />
              <el-button type="primary" size="small" icon="el-icon-search" class="ds-form-inline-btn"
                @click="_openChooseOwner">
                {{ $t('addParkingSpaceApply.selectOwner') }}
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item :label="$t('addParkingSpaceApply.applyPersonLink')" prop="applyPersonLink" :rules="[
              { required: true, message: $t('addParkingSpaceApply.requiredApplyPersonLink') },
              { max: 11, message: $t('addParkingSpaceApply.maxApplyPersonLink') }
            ]">
              <el-input v-model.trim="addParkingSpaceApplyInfo.applyPersonLink"
                :placeholder="$t('addParkingSpaceApply.placeholderApplyPersonLink')" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item :label="$t('addParkingSpaceApply.remark')" prop="remark"
              :rules="[{ max: 300, message: $t('addParkingSpaceApply.maxRemark') }]">
              <el-input v-model.trim="addParkingSpaceApplyInfo.remark" type="textarea"
                :placeholder="$t('addParkingSpaceApply.placeholderRemark')" />
            </el-form-item>
          </el-col>
        </el-row>

        <div class="ds-form-actions">
          <el-button type="warning" @click="_goBack">
            {{ $t('common.back') }}
          </el-button>
          <el-button type="primary" @click="saveParkingSpaceApplyInfo">
            {{ $t('common.submit') }}
          </el-button>
        </div>
      </el-form>
    </div>

    <search-owner ref="searchOwner" @chooseOwner="handleChooseOwner" />
  </div>
</template>

<script>
import { saveParkingSpaceApply } from '@/api/car/addParkingSpaceApplyApi'
import { getDict } from '@/api/community/communityApi'
import SearchOwner from '@/components/owner/SearchOwner'
import DsPageHeader from '@/components/ds/ds-page-header.vue'

export default {
  name: 'AddParkingSpaceApply',
  components: {
    SearchOwner,
    DsPageHeader
  },
  data() {
    return {
      addParkingSpaceApplyInfo: {
        paName: '',
        paId: '',
        psId: '',
        psName: '',
        applyId: '',
        carNum: '',
        carBrand: '',
        carType: '',
        carColor: '',
        applyPersonName: '',
        applyPersonLink: '',
        applyPersonId: '',
        state: '1001',
        remark: ''
      },
      carTypes: []
    }
  },
  async created() {
    await this.getCarTypeDict()
  },
  methods: {
    async getCarTypeDict() {
      try {
        const data = await getDict('owner_car', 'car_type')
        this.carTypes = data
      } catch (error) {
        console.error('获取车辆类型字典失败:', error)
      }
    },
    handleChooseOwner(owner) {
      this.addParkingSpaceApplyInfo.applyPersonName = owner.name
      this.addParkingSpaceApplyInfo.applyPersonLink = owner.link
      this.addParkingSpaceApplyInfo.applyPersonId = owner.ownerId
    },
    _openChooseOwner() {
      this.$refs.searchOwner.open()
    },
    async saveParkingSpaceApplyInfo() {
      try {
        await this.$refs.form.validate()

        const data = {
          ...this.addParkingSpaceApplyInfo,
          communityId: this.getCommunityId()
        }

        await saveParkingSpaceApply(data)
        this.$message.success(this.$t('common.operationSuccess'))
        this.clearAddParkingSpaceApplyInfo()
        this._goBack()
      } catch (error) {
        if (error.errors) {
          this.$message.error(Object.values(error.errors).join('; '))
        } else {
          console.error('保存失败:', error)
        }
      }
    },
    clearAddParkingSpaceApplyInfo() {
      this.addParkingSpaceApplyInfo = {
        paName: '',
        paId: '',
        psId: '',
        psName: '',
        applyId: '',
        carNum: '',
        carBrand: '',
        carType: '',
        carColor: '',
        applyPersonName: '',
        applyPersonLink: '',
        applyPersonId: '',
        state: '1001',
        remark: ''
      }
    },
    _goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.add-parking-space-apply-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &--padded {
    padding: var(--ds-spacing-lg);
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: var(--ds-spacing-md);
    margin-bottom: var(--ds-spacing-lg);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

.ds-form {
  .el-form-item {
    margin-bottom: var(--ds-spacing-lg);
  }
}

.ds-form-inline-btn {
  margin-left: 10px;
}

.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-sm);
  padding-top: var(--ds-spacing-md);
  border-top: 1px solid var(--ds-gray-200);
}
</style>
